export default __webpack_public_path__ + "static/media/9127-richard.5fad2077.pdf";